// Helper function to find a parameter by name and return its formatted value
import { ReturnParameterValue } from '../schemas/ReturnParameterValue';

export const getParameterFormattedValue = (
    parameterValues: ReturnParameterValue[] | undefined,
    parameterName: string
): string => {
    if (!parameterValues) {
        return '';
    }

    const param = parameterValues.find((p) => p.parameterName === parameterName);
    return param?.formattedValue || '';
};

export const getParameterFormattedValueByParameterId = (
    parameterValues: ReturnParameterValue[] | undefined,
    parameterId: number
): string => {
    if (!parameterValues) {
        return '';
    }

    const param = parameterValues.find((p) => p.parameterId === parameterId);
    return param?.formattedValue || '';
};

export const getParameterFormattedValueByParameterIdSupportLanguage = (
    parameterValues: ReturnParameterValue[] | undefined,
    parameterId: number,
    language: string
): string => {
    if (!parameterValues) {
        return '';
    }

    const param = parameterValues.find((p) => p.parameterId === parameterId);

    if (!param) {
        return '';
    }

    const matchedDisplay =
        param.displayNames?.find((display) => display.language === language) ||
        param.displayNames?.find((display) => display.language === 'ENGLISH');

    return matchedDisplay?.display || param.formattedValue || '';
};
